module.exports = "/assets/ed888f61752fe7fc35078acc189eb56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZE.png
// module id = 2061
// module chunks = 0